import classNames from 'classnames';
import './book-event-form-info.scss';
import { useTranslation } from 'react-i18next';
import { Calendar, DollarSign, MapPin, Users } from 'react-feather';

type Props = {
  title: string;
  price: number;
  date: string;
  time: string;
  placesLeft: number;
  capacity: number;
  locationName: string;
  buildingName: string;
  floorNumber: string;
};

const EventFormInfo = (props: Props) => {
  const { t } = useTranslation();

  return (
    <div className="book-event-form-info">
      <div className="book-event-form-title">{props.title}</div>
      <div className="book-event-form-details">
        <div className="book-event-form-detail-item">
          <div className="book-event-form-detail-item-icon">
            <DollarSign size={18} />
          </div>
          <div className="book-event-form-detail-item-price">
            {props.price ? `₪ ${props.price}` : t('FREE')}
          </div>
        </div>
        <div className="book-event-form-detail-item">
          <div className="book-event-form-detail-item-icon">
            <Calendar size={18} />
          </div>
          <div className="book-event-form-detail-item-date-time">
            <div className="book-event-form-detail-item-date">{props.date}</div>
            <div className="book-event-form-detail-item-time">{props.time}</div>
          </div>
        </div>
        {/*<div className="book-event-form-detail-item">*/}
        {/*  <div*/}
        {/*    className={classNames('book-event-form-detail-item-icon', {*/}
        {/*      'book-event-form-detail-item-icon-red': props.placesLeft <= 0,*/}
        {/*    })}*/}
        {/*  >*/}
        {/*    <Users size={19} />*/}
        {/*  </div>*/}
        {/*  <div className="book-event-form-detail-item-tickets-left">*/}
        {/*    {props.capacity === -1*/}
        {/*      ? t('UNLIMITED')*/}
        {/*      : props.placesLeft > 0*/}
        {/*      ? `${props.placesLeft} Tickets left`*/}
        {/*      : t('NO_AVAILABLE_TICKETS')}*/}
        {/*  </div>*/}
        {/*</div>*/}
        <div className="book-event-form-detail-item">
          <div className="book-event-form-detail-item-icon">
            <MapPin size={18} />
          </div>
          <div className="book-event-form-detail-item-location">
            <div className="book-event-form-detail-item-location-name">
              {props.locationName}
            </div>
            <div className="book-event-form-detail-item-location-building">
              {props.buildingName} ,
              {t('FLOOR_NUMBER', {
                floor: props.floorNumber,
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventFormInfo;
